window.addEventListener("RebuyCartUpdated", function (event) {
  let cart = event.detail.cart;
  let freeShippingCost = "0.00";
  let freeShippingCostVal = "0.00";
  let shippingCost = "4.90";
  let shippingCostVal = 490;
  let shippingCostCalculated = "0.00";
  let freeShippingThreshold = 49.0;
  let currentCurrency = window.Shopify.currency.active;

  let cartShippingcostEl = document.querySelector(".cart-shipping_value");
  let cartTotalPrice = Shopify.formatMoney(Number(cart.total_price));
  let cartTotalPriceInclShippingEl = document.querySelector(
    ".cart-subtotal_value"
  );

  if (Number(freeShippingThreshold) <= Number(cartTotalPrice.substring(1))) {
    shippingCostCalculated = freeShippingCostVal;
    cartShippingcostEl.innerHTML = freeShippingCost;
  } else {
    shippingCostCalculated = shippingCostVal;
    cartShippingcostEl.innerHTML = shippingCost;
  }
  let cartTotalPriceInclShipping =
    Number(cart.total_price) + Number(shippingCostCalculated);
  cartTotalPriceInclShippingEl.innerHTML = Shopify.formatMoney(
    Number(cartTotalPriceInclShipping),
    "{{amount}}"
  );

  updateDiscountSuccessTextamount();
  setTimeout(() => {
    updateRebuyCartreviews();
  },500);
  // updateRebuyRecosCartItemsSavings();
  updateCurrencyIcons();
});

let updateDiscountSuccessTextamount = () => {
  let cartDiscountSuccessTextEls = document.querySelectorAll(
    ".rebuy-cart__flyout-item-discount-message"
  );

  cartDiscountSuccessTextEls.forEach((cartDiscountSuccessTextEl) => {
    // get the quantity of the line item
    if (
      cartDiscountSuccessTextEl.parentElement.querySelector(
        ".rebuy-cart__flyout-item-quantity-widget-label span"
      ) === null
    ) {
      return;
    }
    let lineItemQuantity = cartDiscountSuccessTextEl.parentElement
      .querySelector(".rebuy-cart__flyout-item-quantity-widget-label span")
      .nextSibling.nodeValue.toString()
      .trim();
    let cartDiscountSuccessText = cartDiscountSuccessTextEl.innerHTML;

    if (lineItemQuantity >= 4) {
      cartDiscountSuccessText = cartDiscountSuccessText.replace(/10%/g, "20%");
      cartDiscountSuccessTextEl.innerHTML = cartDiscountSuccessText;
    } else if (lineItemQuantity < 3) {
      cartDiscountSuccessText = cartDiscountSuccessText.replace(/20%/g, "10%");
      cartDiscountSuccessTextEl.innerHTML = cartDiscountSuccessText;
    }
  });
};

let updateRebuyCartreviews = () => {
  document
    .querySelectorAll(".rebuy-cart-item-review-snippet")
    .forEach((item) => {
      const handle = item.getAttribute("data-handle-item");
      const cartItem = document.querySelector(
        `.rebuy-cart__flyout-item-info [data-handle="${handle}"]`
      );
      if (cartItem) {

        cartItem.appendChild(item);
        cartItem.addEventListener("click", () => {
          // close the cart
          if (window.Rebuy.SmartCart) {
            window.Rebuy.SmartCart.hide();
          }
        });
      }
    });
};

let updateRebuyRecosCartItemsSavings = () => {
const recoWidget = document.querySelector("#rebuy-widget-211524");
// keep checking if the widget is loaded
if (!recoWidget) {
  setTimeout(updateRebuyRecosCartItemsSavings, 500);
  return;
}
if (recoWidget) {
  const cartItems = recoWidget.querySelectorAll(".rebuy-product-block");
  cartItems.forEach((item) => {
    const originalPrice = item.querySelector(".rebuy-product-price .compare-at span:nth-child(2)");
    const currentPrice = item.querySelector(".rebuy-product-price .sale span:nth-child(2)");
    
    if (originalPrice && currentPrice) {
      const existingSavingsText = item.querySelector(".rebuy-product-price-savings");
      if (existingSavingsText) {
        return;
      }
      let originalPriceValue = originalPrice.innerHTML.replace(/[^0-9.-]+/g, "");
      let currentPriceValue = currentPrice.innerHTML.replace(/[^0-9.-]+/g, "");
      // calc savings to get the discount percentage
      let savings = ((originalPriceValue - currentPriceValue) / originalPriceValue) * 100;
      if (Number.isNaN(savings)) {
        // remove the savings text if the calculation fails
        return;
      }
      savings = Math.round(savings);
      const savingsdiv = document.createElement("div");
      savingsdiv.classList.add("price--on-sale");
      const savingsText = document.createElement("span");
      savingsdiv.appendChild(savingsText);
      savingsText.classList.add("rebuy-product-price-savings");
      savingsText.classList.add("price-item--sale__save-tag");
      savingsText.innerHTML = `SPARE ${savings}%`;
      
      // append
      currentPrice.appendChild(savingsdiv);
      
    }
  });
  updateRebuyRecosCartItemsCtaArrow();
}
}

let updateRebuyRecosCartItemsUnitPrice = () => {
}

let updateRebuyRecosCartItemsCtaArrow = () => {
  const recoWidget = document.querySelector("#rebuy-widget-211524");
  // keep checking if the widget is loaded
  if (!recoWidget) {
    setTimeout(updateRebuyRecosCartItemsCtaArrow, 500);
    return;
  }
  if (recoWidget) {
    const cartItems = recoWidget.querySelectorAll(".rebuy-product-block");
    cartItems.forEach((item) => {
      const ctaButton = item.querySelector(".rebuy-product-actions button");
      if (ctaButton) {
        // retun if icon already exists
        const existingIcon = ctaButton.querySelector(".btn__icon");
        if (existingIcon) {
          return;
        }
        const ctabuttonMarkup = `<svg class="svg-inline--fa fa-arrow-right btn__icon" aria-hidden="true" focusable="false" data-prefix="fat" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M445.5 261.8c1.6-1.5 2.5-3.6 2.5-5.8s-.9-4.3-2.5-5.8l-192-184c-3.2-3.1-8.3-2.9-11.3 .2s-2.9 8.3 .2 11.3L420.1 248 8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l412.1 0L242.5 434.2c-3.2 3.1-3.3 8.1-.2 11.3s8.1 3.3 11.3 .2l192-184z"></path></svg>`
        const ctaButtonSpan = document.createElement("span");
        ctaButtonSpan.innerHTML = ctabuttonMarkup;
        ctaButton.appendChild(ctaButtonSpan);
      }
    });
}
};

window.addEventListener("RebuyUpsellWidgetUpdated", function (event) {
  updateRebuyRecosCartItemsSavings();
});

let updateCurrencyIcons = () => {
  let cartSubCurrency = document.querySelector('.cart-subtotal_currency');
  let cartShippingCurrency = document.querySelector('.cart-shipping_currency');
  let cartTotalCurrency = document.querySelector('.cart-total_currency');
  // get current currency
  let currentCurrency = window.Shopify.currency.active;
  if (currentCurrency === "EUR") {
    cartShippingCurrency.innerHTML = "€";
    cartSubCurrency.innerHTML = "€";
  } else {
    cartShippingCurrency.innerHTML = " CHF";
    cartSubCurrency.innerHTML = " CHF";
  }
  
};

window.addEventListener("RebuyCartReady", function (event) {
  // get current market 
  let currentMarket = window.Shopify.country;
  // set the push-cart checkout button based on the market - span without a class name
  let pushCartCheckoutButton = document.querySelector(
    ".rebuy-cart__checkout-button span:not(.rebuy-checkout-icon)"
  );
  switch (currentMarket) {
    case "CH":
      pushCartCheckoutButton.innerHTML = "Jetzt sicher zur Kassa";
      break;
    case "DE":
      pushCartCheckoutButton.innerHTML = "Jetzt sicher zur Kasse";
      break;
    case "AT":
      pushCartCheckoutButton.innerHTML = "Jetzt sicher zur Kassa";
      break;
    case "LI":
      pushCartCheckoutButton.innerHTML = "Jetzt sicher zur Kassa";
      break;
    default:
      pushCartCheckoutButton.innerHTML = "Jetzt sicher zur Kasse";
  }

});